import * as React from 'react';

import Tooltip from 'components/Tooltip';
import EntityAvatar from 'components/entity/entity-avatar/EntityAvatar';

import TileStandardContext from '../../context/TileStandardContext';

import { __t, applyTranslations } from 'utils/language';
import { getIsBlockedStatus, getLink } from '../../utils/tile-standard';

import './tile-standard-header-avatar.scss';

applyTranslations(require('../tile-standard-header.i18n.json'));

const MSG_KEY = 'tile_standard_header';

const TileStandardHeaderAvatar = React.memo<{}>((): JSX.Element => {
  const content = React.useContext(TileStandardContext);
  const creator = content?.creator;
  const blockUrl = getIsBlockedStatus(content?.isFreemium, content?.tileIndex);
  const updatedUrl = (blockUrl || !creator) ? '#' : getLink(creator);

  const entity = {
    image: {
      url: creator?.profileImage?.url ?? '',
      area: creator?.profileImage?.area
    }
  };

  return (
    <div className="tile-standard-header-avatar">
      <Tooltip
        message={__t(`${MSG_KEY}.tooltips.view_profile`)}
        width="auto-compact"
      >
        <EntityAvatar
          entity={entity}
          link={updatedUrl}
          customSize={{ width: 80, height: 80 }}
          openInNewTab
        />
      </Tooltip>
    </div>
  );
});

export default TileStandardHeaderAvatar;
